(() => {
  const SELECTOR = 'quantity-breaks.ql-enhanced-bundle';

  function repeatVariant(id, qty) {
    const list = [];
    const count = Math.max(1, parseInt(qty || '1', 10));
    for (let i = 0; i < count; i += 1) list.push(String(id));
    return list;
  }

  function getCheckedInput(root) {
    return root.querySelector('input[name="quantity"]:checked');
  }

  function getDetailsForInput(input) {
    if (!input) return null;
    const label = input.nextElementSibling;
    if (!label || !label.classList.contains('quantity-break')) return null;
    return label.querySelector('[data-ql-bundle-details]');
  }

  function setComboRowPrice(details) {
    if (!details || details.dataset.qlCombo !== 'true') return;
    const label = details.closest('.quantity-break');
    if (!label) return;

    const price = label.querySelector('.quantity-break__price');
    const compare = label.querySelector('.quantity-break__compare-price');
    const caption = label.querySelector('.quantity-break__caption');

    if (price && details.dataset.qlComboPrice) {
      price.textContent = details.dataset.qlComboPrice;
    }
    if (compare) {
      const compareText = details.dataset.qlComboCompare || '';
      const priceText = details.dataset.qlComboPrice || '';
      if (compareText && compareText !== priceText) {
        compare.textContent = compareText;
        compare.classList.remove('hidden');
      } else {
        compare.textContent = '';
        compare.classList.add('hidden');
      }
    }
    if (caption && details.dataset.qlComboSaving) {
      caption.textContent = details.dataset.qlComboSaving;
    }
  }

  function updateSubmitAvailability(root, details) {
    const section = root.dataset.section;
    const button = document.getElementById('ProductSubmitButton-' + section);
    if (!button) return;

    if (details && details.dataset.qlCombo === 'true') {
      const available = details.dataset.qlComboAvailable === 'true';
      if (!available) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.qlComboDisabled = 'true';
      } else if (button.dataset.qlComboDisabled === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.qlComboDisabled;
      }
    } else if (button.dataset.qlComboDisabled === 'true') {
      if (button.dataset.unavailable !== 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
      delete button.dataset.qlComboDisabled;
    }
  }

  function applySelection(root) {
    const input = getCheckedInput(root);
    const details = getDetailsForInput(input);

    if (details && details.dataset.qlCombo === 'true') {
      const primaryId = details.dataset.qlComboPrimaryVariant;
      const secondaryId = details.dataset.qlComboSecondaryVariant;
      if (primaryId && secondaryId) {
        root.formVariants = [
          ...repeatVariant(primaryId, details.dataset.qlComboPrimaryQty),
          ...repeatVariant(secondaryId, details.dataset.qlComboSecondaryQty)
        ];
      }
    } else {
      root.formVariants = [];
    }

    updateSubmitAvailability(root, details);
  }

  function init(root) {
    root.querySelectorAll('[data-ql-bundle-details][data-ql-combo="true"]').forEach(setComboRowPrice);

    root.querySelectorAll('input[name="quantity"]').forEach((input) => {
      input.addEventListener('change', () => {
        // Shrine's QuantityBreaks handler runs on the same event.
        // Apply our combo state immediately after it finishes.
        window.setTimeout(() => applySelection(root), 0);
      });
    });

    applySelection(root);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.(SELECTOR).forEach(init);
  });
})();
